module.exports = __webpack_public_path__ + "img/gallery-nft-09.ddc50f59.png";